import { motion, useReducedMotion } from "framer-motion";

// Scroll reveal using pure CSS scroll-driven animations (animation-timeline: view()).
// Content is ALWAYS visible by default; the reveal is a progressive enhancement,
// so it can never leave content hidden (unlike JS/observer-gated approaches).
export const Reveal = ({ children, delay = 0, className = "" }) => {
  return (
    <div className={`reveal ${className}`} style={{ "--reveal-delay": `${delay}s` }}>
      {children}
    </div>
  );
};

// Masked line-by-line reveal for the hero (mount animation via framer-motion).
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { opacity: 0 } : { y: "110%" }}
            animate={reduce ? { opacity: 1 } : { y: "0%" }}
            transition={{
              duration: 1.1,
              delay: delay + i * 0.12,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
